import { useState } from "react";
import {
  Box,
  Select,
  MenuItem,
  TextField,
  SelectChangeEvent,
} from "@mui/material";

type Props = {
  options: string[];
  defaultGenre?: string;
  onGenreChange?: (genre: string) => void;
  searchKeyword: string;
  onKeywordChange?: (keyword: string) => void;
  autoFocus?: boolean;
  onEnter?: () => void;
};

const SearchByGenre = ({
  options,
  defaultGenre = "",
  onGenreChange,
  searchKeyword,
  onKeywordChange,
  autoFocus = false,
  onEnter,
}: Props) => {
  const [selectedGenre, setSelectedGenre] = useState(defaultGenre);

  const handleGenreChange = (event: SelectChangeEvent) => {
    const newGenre = event.target.value;
    setSelectedGenre(newGenre);
    onGenreChange?.(newGenre);
  };

  const handleKeywordChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onKeywordChange?.(event.target.value);
  };

  return (
    <Box display="flex" gap={2}>
      <Select
        value={selectedGenre}
        onChange={handleGenreChange}
        displayEmpty
        size="small"
        sx={{ height: 40, width: "200px" }}
      >
        {options.map((genre) => (
          <MenuItem key={genre} value={genre}>
            {genre}
          </MenuItem>
        ))}
      </Select>

      <TextField
        placeholder={
          selectedGenre
            ? `${selectedGenre}で検索`
            : "ジャンルを選択してください"
        }
        size="small"
        value={searchKeyword}
        onChange={handleKeywordChange}
        autoFocus={autoFocus}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            onEnter?.(); // ← Enter押下時に呼び出す
          }
        }}
        sx={{ width: "275px" }}
      />
    </Box>
  );
};

export default SearchByGenre;
